import { render, staticRenderFns } from "./OffCanvasDetailsTuote.vue?vue&type=template&id=206691b8&scoped=true&"
import script from "./OffCanvasDetailsTuote.vue?vue&type=script&lang=js&"
export * from "./OffCanvasDetailsTuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206691b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('206691b8')) {
      api.createRecord('206691b8', component.options)
    } else {
      api.reload('206691b8', component.options)
    }
    module.hot.accept("./OffCanvasDetailsTuote.vue?vue&type=template&id=206691b8&scoped=true&", function () {
      api.rerender('206691b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OffCanvasDetailsTuote.vue"
export default component.exports